import React from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { formatEuroAmount } from '../../lib/utils';

export const AdminStatsCards = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>Total Propiedades</CardDescription>
          <CardTitle className="text-3xl">{stats.total}</CardTitle>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>Pagadas</CardDescription>
          <CardTitle className="text-3xl text-blue-600">{stats.paid}</CardTitle>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>Publicadas</CardDescription>
          <CardTitle className="text-3xl text-green-600">{stats.published}</CardTitle>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardDescription>Ingresos Totales</CardDescription>
          <CardTitle className="text-3xl text-purple-600">{formatEuroAmount(stats.revenue, { suffix: 'EUR' })}</CardTitle>
        </CardHeader>
      </Card>
    </div>
  );
};
